import { PaddedFormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';
import { FormField } from 'ui/formField';
import { BasicSelect } from 'ui/selects';
import noop from 'utils/noop';
import { DEFAULT_IN_APP_PRIORITY, IN_APP_PRIORITIES } from './DisplayPriority.constants';

export interface DisplayPriorityProps {
  priorityLevel?: number;
  onChange: (level: number) => void;
  isDisabled?: boolean;
}

export const DisplayPriority = ({
  priorityLevel,
  onChange = noop,
  isDisabled = false,
}: DisplayPriorityProps) => {
  return (
    <PaddedFormSectionContent>
      <FormField labelText="Display priority" inputId="display-priority-field">
        <BasicSelect
          id="select-display-priority"
          defaultValues={priorityLevel ? [priorityLevel] : [DEFAULT_IN_APP_PRIORITY]}
          onSelect={([selectedLevel]) => onChange(selectedLevel)}
          // @ts-ignore
          options={IN_APP_PRIORITIES}
          isDisabled={isDisabled}
          isFullWidth
        />
      </FormField>
    </PaddedFormSectionContent>
  );
};

export default DisplayPriority;
